import React from "react";
import { RegulatorModuleProps } from "../../../../types/cdd-records.types";
import { LicenceCard } from "./LicenceCard";

export const RegulatorModule: React.FC<RegulatorModuleProps> = ({
  licences,
}) => {
  const currentLicences = licences.filter((l) => l.status === "current");
  const otherLicences = licences.filter((l) => l.status !== "current");

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Regulatory Licences
            </h3>
            <p className="text-sm text-gray-500 mt-1">
              AFSL, ACL, RSE, and other regulatory authorisations
            </p>
          </div>
          <div className="flex items-center gap-3">
            <span className="px-3 py-1 bg-green-100 text-green-700 text-sm font-medium rounded">
              {currentLicences.length} Active
            </span>
            {otherLicences.length > 0 && (
              <span className="px-3 py-1 bg-gray-100 text-gray-600 text-sm font-medium rounded">
                {otherLicences.length} Inactive
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="p-6">
        {licences.length === 0 ? (
          <div className="text-center py-8">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <h3 className="mt-2 text-sm font-medium text-gray-900">
              No regulatory licences
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              No regulatory licences are currently on file.
            </p>
          </div>
        ) : (
          <div className="space-y-6">
            {/* Active Licences */}
            {currentLicences.length > 0 && (
              <div>
                <h4 className="text-sm font-semibold text-green-700 mb-3 flex items-center gap-2">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Active Licences
                </h4>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {currentLicences.map((licence, index) => (
                    <LicenceCard key={index} licence={licence} />
                  ))}
                </div>
              </div>
            )}

            {/* Inactive Licences */}
            {otherLicences.length > 0 && (
              <div>
                <h4 className="text-sm font-semibold text-gray-500 mb-3 flex items-center gap-2">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  Inactive/Historical Licences
                </h4>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                  {otherLicences.map((licence, index) => (
                    <LicenceCard key={index} licence={licence} />
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default RegulatorModule;
